import styled, { CSSObject } from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'
import { BsChevronLeft as BackArrow } from 'react-icons/bs'

const OverlayHeader = styled.div<StyledHTMLElement>(({ theme }) => ({
  display: 'flex',
  padding: '20px 12px 20px',
  alignItems: 'center',
  borderBottom: 'solid 2px #F0F0F0',
  position: 'sticky',
  zIndex: 1,
  top: 0,
  backgroundColor: 'white',
  [theme.mediaQueries.viewport7]: {
    padding: '20px 28px 20px'
  }
}))

const OverlayTitle = styled.h1<StyledHTMLElement>(
  (): CSSObject => ({
    fontSize: '20px',
    margin: 'auto'
  })
)

const OverlayInputContainer = styled.div<StyledHTMLElement>(
  (): CSSObject => ({
    marginLeft: '24px',
    width: '100%'
  })
)

/** Common JSX for overlays with title in overlay header */
export const CommonOverlayTitleHeader = ({
  modalTitle,
  onBackClick
}: {
  modalTitle: string
  onBackClick: (event: any) => void
}): JSX.Element => (
  <OverlayHeader>
    <OverlayHeaderIconContainer onClick={onBackClick}>
      <BackArrow />
    </OverlayHeaderIconContainer>
    <OverlayTitle>{modalTitle}</OverlayTitle>
  </OverlayHeader>
)

/** Common JSX for overlays with an input in overlay header */
export const CommonOverlayInputHeader = ({
  children,
  onBackClick
}: {
  children: JSX.Element
  onBackClick: (event: any) => void
}): JSX.Element => (
  <OverlayHeader>
    <IconContainer onClick={onBackClick}>
      <BackArrow />
    </IconContainer>
    <OverlayInputContainer>{children}</OverlayInputContainer>
  </OverlayHeader>
)
export const IconContainer = styled.div<StyledHTMLElement>(({ theme }) => ({
  cursor: 'pointer',
  alignItems: 'center',
  display: 'flex',
  padding: '4px',
  '> svg': {
    width: '16px',
    [theme.mediaQueries.viewport7]: {
      width: '14px'
    }
  }
}))

const OverlayHeaderIconContainer = styled(IconContainer)<StyledHTMLElement>(
  (): CSSObject => ({
    position: 'absolute'
  })
)

export const ListItem = styled.li<
  StyledHTMLElement & {
    disabled?: boolean
    showFulfillmentWindow?: boolean
    isStoreList?: boolean
  }
>(({ disabled, showFulfillmentWindow, isStoreList, theme }) => ({
  listStyleType: 'none',
  position: showFulfillmentWindow ? 'relative' : 'initial',
  cursor: 'pointer',
  padding: showFulfillmentWindow ? '16px 20px 4px' : '16px 20px',
  margin: 0,
  fontSize: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '&:hover': {
    background: '#f1f1f1'
  },
  '&:active': {
    fontWeight: 500,
    color: '#096DD9'
  },
  color: disabled ? '#AEB4C2' : 'black',
  pointerEvents: disabled ? 'none' : 'auto',
  [theme.mediaQueries.viewport7]: {
    padding: showFulfillmentWindow
      ? '16px 32px 4px'
      : isStoreList
        ? '16px 32px 0'
        : '16px 32px'
  }
}))

export const LineBreak = styled.hr<StyledHTMLElement>(({ theme }) => ({
  backgroundColor: '#F0F0F0',
  border: '0',
  height: '1px',
  margin: '0 20px',
  [theme.mediaQueries.viewport7]: {
    margin: '0px 32px'
  }
}))

export const ListItemWrapper = styled.div<StyledHTMLElement>(
  (): CSSObject => ({
    cursor: 'pointer',
    '&:hover': {
      background: '#f1f1f1'
    },
    '&:active': {
      fontWeight: 500,
      color: '#096DD9'
    },
    '&:last-of-type': {
      '> hr': {
        display: 'none'
      }
    }
  })
)

export const DeliveryFormHeading = styled.h2<StyledHTMLElement>(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    margin: '16px 0 8px',
    fontWeight: 'normal',
    fontSize: '20px',

    '> span': {
      flexGrow: 1,
      fontSize: '16px',
      color: '#666666',
      fontWeight: 500
    },

    [theme.mediaQueries.viewport7]: {
      fontWeight: 'bold'
    }
  })
)

export const ListItemIconContainer = styled(IconContainer)<
  StyledHTMLElement & { showFulfillmentWindow?: boolean }
>(({ showFulfillmentWindow, theme }) => ({
  position: showFulfillmentWindow ? 'absolute' : 'initial',
  top: showFulfillmentWindow ? '60%' : 'unset',
  right: showFulfillmentWindow ? '16px' : 'initial',
  display: 'flex',
  cursor: 'pointer',
  alignSelf: 'end',
  [theme.mediaQueries.viewport7]: {
    right: showFulfillmentWindow ? '28px' : 'initial'
  },
  '> svg': {
    width: '16px',
    [theme.mediaQueries.viewport7]: {
      width: '14px'
    }
  }
}))

export const RequiredTag = styled.p<
  StyledHTMLElement & { isValid?: boolean; hasFailed?: boolean }
>(({ theme, isValid = false, hasFailed = false }) => ({
  fontSize: '14px',
  display: 'inline-flex',
  textTransform: 'lowercase',
  fontStyle: 'italic',
  fontWeight: 300,
  color: isValid
    ? theme.colors['state']['success'][5]
    : hasFailed
      ? theme.colors['state']['failure'][5]
      : 'black'
}))
